import { DataTypes } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema, FieldValue, FieldValues } from "../../../Schema";
import { SubEquipmentConnection } from "../../cluster";

/**
 * Id of the sub-equipment whose software version leads the cluster. Derived from
 * the GraphQL `subEquipment` connection (the item flagged isClusterSWVersion) and
 * managed by the cluster components preview (not shown as its own input).
 */
export const leadingSoftwareVersionId: FieldSchema = {
  name: "leadingSoftwareVersionId",
  // Derived from the `subEquipment` connection (the item flagged
  // `isClusterSWVersion`), not a real GraphQL field — exclude it from the
  // schema-derived Selection.
  graphql: { selection: undefined },
  data: {
    type: DataTypes.STRING,
    active: true,
  },
  dataTransform: {
    fromGraphql: {
      getter: ({ subEquipment }: FieldValues) => {
        const items = (subEquipment as SubEquipmentConnection)?.items ?? [];
        return (items.find((item) => item?.isClusterSWVersion)?.id ?? null) as FieldValue;
      },
      fields: ["subEquipment"],
    },
    toGraphql: undefined,
  },
  form: {
    type: InputTypes.TEXT,
    displayed: false,
  },
};
